import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PetContextService } from '../../services/pet-context.service';

@Component({
  selector: 'app-pet-pairing',
  templateUrl: './pet-pairing.component.html',
  styleUrls: ['./pet-pairing.component.css']
})
export class PetPairingComponent implements OnChanges, OnDestroy {
  @Input() suspended = false;
  open = false;
  busy = false;
  pairing = '';
  error = '';
  active = false;
  private expiry: ReturnType<typeof setTimeout>;
  private readonly subscription: Subscription;

  constructor(private pet: PetContextService) {
    this.subscription = pet.connected$.subscribe(active => {
      this.active = active;
      if (!active) this.pairing = '';
    });
  }

  ngOnChanges(): void {
    this.pet.setSuspended(this.suspended);
    if (this.suspended) { this.open = false; this.pairing = ''; }
  }

  async pair(): Promise<void> {
    this.busy = true;
    this.error = '';
    try {
      const result = await this.pet.pair();
      if (!this.suspended) this.pairing = result.text;
      clearTimeout(this.expiry);
      this.expiry = setTimeout(() => { this.pairing = ''; }, Math.max(0, Date.parse(result.expiresAt) - Date.now()));
    } catch (_) {
      this.error = '目前無法配對，請確認站台即時連線及寵物 Hub 已部署後重試。';
    } finally { this.busy = false; }
  }

  disconnect(): void { this.pairing = ''; void this.pet.disconnect(); }

  ngOnDestroy(): void {
    clearTimeout(this.expiry);
    this.subscription.unsubscribe();
    void this.pet.disconnect();
  }
}
